// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3I8wv","colBig":"styles_colBig__3ijsg","colSmall":"styles_colSmall__3vlk6"};